@if (isLoading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="dashboard-edit-component">
  <div [formGroup]="form" formContainerCol class="p-3 mt-2">
    <div formContainerFormRow>
      <div class="form-group mb-2">
        <cc-color-picker [position]="'right'" formControlName="color">
          {{ 'DASHBOARDPANEL.PROPERTIES.COLOR' | transloco }}
        </cc-color-picker>
      </div>
    </div>
    <div class="form-row">
      <div class="dashboard-edit-name-fields">
        <cc-input-translation
          [containerClasses]="'name-container'"
          [label]="'DASHBOARDPANEL.PROPERTIES.NAME'"
          [required]="true"
          formControlName="name"
        ></cc-input-translation>
      </div>
    </div>

    <div formContainerFormRow>
      <div class="form-group col-lg-12">
        <cc-input-translation
          [containerClasses]="'description-container'"
          [label]="'DASHBOARDPANEL.PROPERTIES.DESCRIPTION'"
          [longText]="true"
          formControlName="description"
        ></cc-input-translation>
      </div>
    </div>

    <div formContainerFormRow>
      <mat-form-field>
        <mat-label>{{ 'common.TENANT' | transloco }}</mat-label>
        <mat-select formControlName="tenant" id="tenant" multiple>
          @for (tenant of tenants$ | async; track tenant) {
            <mat-option value="{{ tenant.tenant }}"
              >{{ tenant.tenant }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (tenant.errors?.['tenantIsNotValid']) {
        <div class="dashboard-edit-field-error" role="alert">
          {{ 'DASHBOARDPANEL.TENANT_NOT_ALLOWED' | transloco }}
        </div>
      }
    </div>

    <mat-checkbox formControlName="shared">{{
      'DASHBOARDPANEL.PROPERTIES.SHARED' | transloco
    }}</mat-checkbox>
    <div class="form-row" [hidden]="!isShared">
      <div class="form-group col-lg-12">
        <cc-visible-to formControlName="visibleTo"></cc-visible-to>
      </div>
    </div>
  </div>
</div>
